import { Component, OnInit, ViewChild, AfterViewInit, ElementRef, Input, OnChanges, OnDestroy } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { CurrencyPipe } from '@angular/common';

import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';

import { HelperService, HTTPService, DataService, CalculationService, FormatService } from 'app/services';
import { find, debounce, findIndex } from 'lodash';
import { UpdateCannedServiceDialogComponent } from '../update-canned-service-dialog/update-canned-service-dialog.component';
import { DeleteCategoryDialogComponent } from '../delete-category-dialog/delete-category-dialog.component';
import { currency } from 'app/constants/currency.constants';
import { config, messages } from 'app/constants';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-labor-add',
  templateUrl: './labor-add.component.html',
  styleUrls: ['./labor-add.component.scss'],
  animations: [
    trigger('toggleBox', [
      state(
        'open',
        style({
          height: '135px',
        }),
      ),
      state(
        'closed',
        style({
          height: '0px',
        }),
      ),
      transition('open => closed', [animate('0.0s')]),
      transition('closed => open', [animate('0.0s')]),
    ]),
  ],
})
export class LaborAddComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @Input() isGlobalCategoryEnabled: boolean = false;
  @Input() qboItemRefs: any[] = [];
  @Input() pricings: any[] = [];
  @Input() isLoading: boolean = false; // don't set this key inside this component
  @Input() data: any = {};
  @Input() item: any = {};
  @Input() stock: any = {};
  @Input() laborId: string = '';
  @Input() isLocal: boolean = true;
  @Input() isQboConnected: boolean = false;
  @Input() isOpenFromPO: boolean = false;
  @Input() isInventoryEnabled: boolean = false;
  @Input() isTaxable: boolean = false;
  @Input() orderServiceItemIndex: number = -1;
  @Input() orderServiceId: string = '';
  @Input() openFrom: string = '';
  @Input() motorMarkup: any = '';
  @Input() serviceItem: any = {};
  @Input() defaultTaxable: boolean = false;
  @Input() isOpenFromRO: boolean = false;
  @Input() isFeeAssociationEnabled: boolean = false;
  @Input() isCommissionPlanEnabled: boolean = false;
  @Input() isNewItemCategoriesEnable: boolean = false;
  @Input() isAttributeBasedPricingEnable: boolean = false;
  @Input('titleForCreate')
  set titleForCreate(title: any) {
    if (title) {
      this.labor.title = title;
      this.checkUniqueTitle();
    }
  }
  @Input() categories: any[] = [];
  @Input() categoryType: string = '';
  @Input() isPricingMatricesManagement: boolean = false;
  @Input() isPricingManagementEnable: boolean = false;
  @Input() isFinalizedRo: boolean = false;
  @Input() canEditClassifications: boolean = false;

  @ViewChild('autoCompleteCustomer', { static: true })
  autoCompleteCategory: ElementRef;

  integrationPartner: string[] = ['Motor', 'Mitchell1', 'PartsTech', 'Nexpart', 'TireHub', 'TireConnect', 'RepairLink', 'SpeedDial'];
  selectedTab: number = 0;
  activityLogs: any[] = [];
  isQuickbooksConnected: boolean = false;
  activeInput: string = 'name';
  usd: string = currency.USD;
  laborPricings: any[] = [];
  itemResults: any[] = [[]];
  isSearching: boolean = false;
  config: any = config;
  categoryResults: any[] = [];
  categoryName: any = '';
  isShowError: boolean = false;
  categorId: any = '';
  labor: any = {
    _id: '',
    type: 'labor',
    title: '',
    titleFR: '',
    code: '',
    billRate: '',
    billableHours: '',
    price: '',
    costEstimatedHours: '',
    costRate: '',
    cost: '',
    discription: '',
    discriptionFR: '',
    itemRef: '',
    locationQboItemRefId: {},
    status: true,
    isTaxable: false,
    displayHoursOnOrder: true,
    displayDescOnOrder: true,
    commissionable: true,
    notes: '',
    internalNotes: '',
    category: { name: '' },
    isChangeInPriceMatrix: false,
  };

  hazmatFeeObject: any = {};
  hazmatFeeArray: any[] = [];
  errors: any = {};
  focus: any = { name: true };
  numberObj = Number;
  isProcessing: boolean = false;
  checkUniqueTitle = debounce(this._checkUniqueTitle, 600);
  checkUniqueCategory = debounce(this._checkUniqueCategory, 600);
  isTitleUnique: boolean = true;
  updateGenericItem: boolean = false;
  defaultQboItems: any[] = [];
  // used to maintain state changes for each component
  initalInputStates = <any>{};
  updatedInputStates = <any>{};
  defaultBillableHours: number = 0;
  defaultActiveState: boolean = true;
  defaultPrice: number = 0;
  isChangeInPriceMatrix: boolean = false;
  isMultiLocationEnabled: boolean = false;
  currentShopId: string = '';
  isNewCategoriesEnabled: boolean = false;
  isSalesCodeEnabled: boolean = false;

  categoriesSuggestions: any[] = [];
  subCategoriesSuggestions: any[] = [];
  subSubCategoriesSuggestions: any[] = [];
  isLockedRO = false;
  categoriesSuggestionsResults: any[] = [];
  subCategoriesSuggestionsResults: any[] = [];
  subSubCategoriesSuggestionsResults: any[] = [];
  loader = {
    category: false,
    subCategory: false,
    subSubCategory: false,
  };
  classificationPrivilegeMsg: string = messages.classificationPrivilegeMsg;
  defaultSalesCode: any = {};
  //salesCodeOverideConfirm: boolean = false;
  isAutoAssign: boolean = false;
  localizationSubscription: Subscription;
  companyLocalization: boolean = false;
  currentLang: string = 'en';
  logPageSize: number = config.activitylogPageSize;

  constructor(
    private helperService: HelperService,
    private httpService: HTTPService,
    private formatService: FormatService,
    public calculationService: CalculationService,
    private dynamicDialogRef: DynamicDialogRef,
    private dataService: DataService,
    private dialogService: DialogService,
    private currencyPipe: CurrencyPipe,
  ) {}

  ngOnInit() {
    if (this.dataService.isNewItemCategoriesEnable) this.getAllCategories();
    if (this.laborId) {
      this.getLogs();
    }
    if (this.isOpenFromRO) {
      this.isLockedRO = this.dataService.isLockedRO;
    }
    this.getLocalizationFlags();
  }

  ngAfterViewInit() {}

  getLocalizationFlags() {
    const { isMultiLocationEnabled } = this.helperService.getCompany();
    this.localizationSubscription = this.dataService.getCompanyLocalization().subscribe((value) => {
      if (value) {
        this.companyLocalization = value;
        if (!isMultiLocationEnabled) {
          this.httpService.getCompanyPreferredLanguage().then((res: any) => {
            const lang = res.preferredLanguage;
            if (lang) {
              this.currentLang = lang.toLowerCase();
            }
          });
        } else {
          this.httpService.getCompanyDetails(this.helperService.getCompany().companyId).then((company: any) => {
            const lang = company.shop.preferredLanguage;
            if (lang) this.currentLang = lang.toLowerCase();
          });
        }
      }
    });
  }

  ngOnDestroy() {
    if (this.localizationSubscription) this.localizationSubscription.unsubscribe();
  }

  ngOnChanges(change: any) {
    const { isLoading } = change;

    if (isLoading) {
      if (isLoading.previousValue && !isLoading.currentValue) {
        if (!this.laborId) {
          this.defaultTaxable = this.isTaxable;
          this.labor.isTaxable = this.isTaxable;
        }
        this.currentShopId = localStorage.getItem('currentShop');
        const { isMultiLocationEnabled } = this.helperService.getCompany();
        this.isMultiLocationEnabled = isMultiLocationEnabled;
        this.isNewCategoriesEnabled = this.dataService.isNewItemCategoriesEnable;
        this.isSalesCodeEnabled = this.dataService.isSalesCodeEnabled;
        this.initializePricings();
        this.setItemDetails(this.item);
        this.setCategories(this.categories);
        this.hazmatFeeArray.push({});
        this.isProcessing = false;
      }
    }
  }

  logPXGaingSightCustomEvent(res: any) {
    if (res?.salesCode?.salesCodeId && res?.salesCode?.salesCodeId !== this.defaultSalesCode?.salesCodeId) {
      const logInfo = {
        itemName: res?.title || res?.name,
        salesCodeName: res?.salesCode?.title,
        salesCode: res?.salesCode?.shortName,
        category: res?.category?.name,
        subCategory: res?.category?.subCategoryName,
        itemType: res?.type,
        assignmentType: this.isAutoAssign ? 'Auto' : 'User has assigned sales code directly from the Catalog/RO',
      };
      this.helperService.logPXGaingSightEvent('Sales code assigned to an item', logInfo);
    }
  }

  openAssignSalesCodeDialog() {
    if (!this.canEditClassifications && !this.isOpenFromRO) {
      return;
    }
    const data = {
      item: this.labor,
      openFrom: 'labor-add-modal',
    };
    data.item.title = data.item?.title || '';
    this.dataService.sendData(this.dataService.typeDialog('open-sales-code-assign-modal', 'labor-add-modal', null, null, data));
  }

  getLogs() {
    const query = <any>{};
    query.entityId = this.laborId;
    query.isItemLogs = true;
    query.limit = 5;
    query.skip = this.logPageSize;
    this.logPageSize = this.logPageSize + query.limit;

    this.httpService.getActivityLog(query).then(
      (data: any) => {
        console.log(data);
        if (data.records.length) {
          const activityLogs = this.formatService.formateCatlogActivityLogs(data.records);
          this.activityLogs = [...this.activityLogs, ...activityLogs];
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  onScroll = debounce((event: any, type: string) => {
    this.getLogs();
  }, 1000);

  deleteCategoryDialog(e) {
    this.httpService
      .getAllCategories(e._id)
      .then((data: any) => {
        if (data.length) {
          const ref = this.dialogService.open(DeleteCategoryDialogComponent, {
            width: '1200px',
            styleClass: 'add-dialog overflow-initial delete-category-dialog',
            showHeader: false,
            data: {
              selectedCategory: e,
              categoryList: this.categoryResults,
              type: 'labor',
              isOnlyDelete: false,
              count: data.length,
            },
          });
          const onClose = ref.onClose.subscribe(({ isSuccess, data, selectedName }) => {
            if (isSuccess) {
              const { categoryId, name } = data.category;
              if (this.labor && this.labor.category?.name === name) {
                this.labor.category.name = selectedName;
              }
              this.categories.map((item, index) => {
                if (item._id === categoryId) this.categories.splice(index, 1);
              });
              this.categoryResults = [...this.categories];
            }
            onClose.unsubscribe();
          });
        } else if (data.length === 0) {
          const ref = this.dialogService.open(DeleteCategoryDialogComponent, {
            width: '1200px',
            styleClass: 'add-dialog overflow-initial delete-category-dialog',
            showHeader: false,
            data: {
              selectedCategory: e,
              categoryList: this.categoryResults,
              type: 'labor',
              isOnlyDelete: true,
              count: 0,
            },
          });
          const onClose = ref.onClose.subscribe(({ isSuccess, data, selectedName }) => {
            if (isSuccess) {
              const { categoryId, name } = data.category;
              if (this.labor && this.labor.category?.name === name) {
                this.labor.category.name = selectedName;
              }
              this.categories.map((item, index) => {
                if (item._id === categoryId) this.categories.splice(index, 1);
              });
              this.categoryResults = [...this.categories];
            }
            onClose.unsubscribe();
          });
        }
      })
      .catch((err) => this.helperService.showToaster('error', err));
  }

  setCategories(categories: any[]) {
    this.categoryResults = [...categories];
  }

  initializePricings() {
    this.laborPricings = this.pricings.map((pricing: any) => ({
      ...pricing,
      name: `${pricing.name} - ${this.currencyPipe.transform(pricing.rate, this.usd)}`,
    }));

    // set default labor pricing on init labor item
    if (!this.laborId && this.laborPricings.length) {
      this.labor.pricing = this.laborPricings.filter((item) => item.default)[0];
      this.labor.billRate = { rate: this.labor?.pricing?.rate || 0 };
    }
    this.setLaborRate();
  }

  setItemDetails(labor: any) {
    if (labor && this.laborId) {
      this.labor = {
        type: 'labor',
        title: labor.title,
        titleFR: labor.titleFR,
        code: labor.code,
        salesCode: labor.salesCode,
        billRate: { rate: labor.billRate },
        billableHours: labor.billableHours,
        price: labor.price,
        costEstimatedHours: labor.costEstimatedHours,
        costRate: labor.costRate,
        cost: labor.cost,
        itemRef: { qboId: labor.qboItemRefId },
        locationQboItemRefId: labor.locationQboItemRefId || {},
        status: labor.status,
        isTaxable: labor.isTaxable,
        displayHoursOnOrder: labor.displayHoursOnOrder,
        displayDescOnOrder: labor.displayDescOnOrder,
        commissionable: labor.commissionable,
        notes: labor.notes,
        descriptionFR: labor.descriptionFR,
        internalNotes: labor.internalNotes,
        pricing: (labor.pricing && labor.pricing.pricingId) || {},
        category: labor.category || {},
        isChangeInPriceMatrix: labor.isChangeInPriceMatrix || false,
        shopDetails: labor?.shopDetails,
      };

      if (this.isNewCategoriesEnabled) {
        this.labor.category = labor.category;
      }

      this.defaultActiveState = labor.status;
      this.initalInputStates = this.helperService.deepCopy(this.labor);

      if (labor.pricing && labor.pricing.pricingId) {
        this.labor.pricing.pricingId = this.labor.pricing._id;
        this.labor.billRate.name = this.labor.pricing.name;
      }
      this.defaultBillableHours = this.labor.billableHours;
      this.defaultPrice = this.labor.price;

      if (labor.associatedItems && labor.associatedItems.length > 0) {
        this.hazmatFeeArray = labor.associatedItems.map(({ itemId }) => itemId);
      }

      if (this.isSalesCodeEnabled) {
        this.defaultSalesCode = this.helperService.deepCopy(labor?.salesCode);
      }
    } else {
      this.labor.commissionable = this.dataService.isCommissionLabor;
    }

    this.checkShopLevelDetails();
    this.setItemRef();
    this.setOrderService();
    this.setLaborRate();
    //Do not forcefully empty the description EN it creates this issue ALP-21023
    // if (this.companyLocalization) {
    //   if (this.currentLang == 'fr') {
    //     this.labor.notes = '';
    //   }
    // }
  }

  checkShopLevelDetails() {
    const currentShopItemDetails = this.labor?.shopDetails?.find((s) => s.shopId === this.helperService.getCurrentShopId());
    if (currentShopItemDetails) {
      this.labor.price = currentShopItemDetails.price;
    }
  }

  _checkUniqueTitle() {
    if (this.integrationPartner.includes(this.serviceItem?.itemSource)) return;

    this.httpService.isItemTitleUnique({ title: this.labor.title.trim(), type: 'labor' }, this.laborId).then(
      (res) => {
        if (!res) {
          this.errors.title = 'Labor name must be unique';
          this.isTitleUnique = false;
          this.helperService.showToaster('error', 'Labor name must be unique');
        } else {
          this.errors.title = '';
          this.isTitleUnique = true;
        }
      },
      (err) => {
        console.error(err);
      },
    );
  }

  _checkUniqueCategory() {
    this.httpService.isCategoryUnique({ name: this.categoryName.trim(), type: 'item' }, this.categorId).then(
      (res) => {
        if (!res) {
          this.isShowError = true;
        } else {
          this.isShowError = false;
        }
      },
      (err) => {
        console.error(err);
      },
    );
  }

  /** Set Item Ref */
  setItemRef() {
    if (this.labor && this.labor.itemRef && this.labor.itemRef.qboId && this.qboItemRefs.length) {
      this.labor.itemRef = find(this.qboItemRefs, {
        qboId: this.labor.itemRef.qboId,
      });
    }
    // if its an multiLocation tenant check that location level ref is saved then override the ref
    if (this.isMultiLocationEnabled) {
      if (this.labor && this.labor.locationQboItemRefId && this.labor.locationQboItemRefId[this.currentShopId] && this.qboItemRefs.length) {
        const refId = this.labor.locationQboItemRefId[this.currentShopId];
        this.labor.itemRef = find(this.qboItemRefs, {
          qboId: refId,
        });
      }
    }
  }

  setLaborRate() {
    if (this.labor.pricing && this.labor.pricing._id && this.laborPricings.length) {
      const pricing = find(this.laborPricings, {
        _id: this.labor.pricing._id,
      });

      if (pricing && pricing._id) {
        if (Number(this.labor.billRate.rate) === Number(pricing.rate)) {
          this.labor.billRate = pricing;
        } else {
          this.labor.billRate = {
            name: `Labor - ${this.currencyPipe.transform(this.labor.billRate.rate || 0, this.usd)}`,
            rate: this.labor.billRate.rate,
          };
        }

        if (this.labor.billRate && this.labor.billRate.rate >= 0 && this.labor.billableHours >= 0) {
          this.labor.price = this.calculationService.roundOff(this.labor.billRate.rate * this.labor.billableHours);
        }
      } else {
        this.labor.billRate = {
          name: `Labor - ${this.currencyPipe.transform(this.labor.billRate.rate || 0, this.usd)}`,
          rate: this.labor.billRate.rate,
        };
        this.labor.price = this.calculationService.roundOff(this.labor.billRate.rate * this.labor.billableHours);
      }
    } else if (this.labor.pricing && !this.labor.pricing._id && this.labor.billRate && this.labor.billRate.rate >= 0) {
      const pricing = find(this.laborPricings, {
        rate: this.labor.billRate.rate,
      });

      if (pricing && pricing._id) {
        this.labor.billRate = {
          name: pricing.name,
          rate: this.labor.billRate.rate,
        };
        this.labor.pricing = pricing;
        this.labor.pricing.pricingId = pricing._id;
      } else {
        this.labor.billRate = {
          name: `Labor - ${this.currencyPipe.transform(this.labor.billRate.rate || 0, this.usd)}`,
          rate: this.labor.billRate.rate,
        };
      }

      this.labor.price = this.calculationService.roundOff(this.labor.billRate.rate * this.labor.billableHours);
    }
  }

  setOrderService() {
    if (this.serviceItem && this.serviceItem.itemId) {
      this.labor.title = this.serviceItem.title;
      this.labor.description = this.serviceItem.description;
      this.labor.descriptionFR = this.serviceItem.descriptionFR;
      this.labor.notes = this.serviceItem.description;
      this.labor.internalNotes = this.serviceItem.internalNotes;
      this.labor.billableHours = this.serviceItem.count;
      this.labor.isChangeInPriceMatrix = this.serviceItem.isChangeInPriceMatrix || false;

      if (this.serviceItem.pricing && this.serviceItem.pricing.pricingId) {
        this.labor.pricing = this.serviceItem.pricing;
        this.labor.pricing._id = this.serviceItem.pricing.pricingId;
      } else {
        this.labor.pricing = {};
      }

      this.labor.billRate = { rate: this.serviceItem.price };

      if (this.defaultBillableHours !== this.labor.billableHours) {
        this.calculateLaborPrice();
        this.defaultPrice = this.labor.price;

        if (this.labor.billableHours !== this.defaultBillableHours && this.defaultBillableHours > 0) {
          this.labor.costEstimatedHours = this.calculationService.roundOff((this.labor.billableHours / this.defaultBillableHours) * this.labor.costEstimatedHours);

          this.defaultBillableHours = this.labor.billableHours;
          this.calculateTotalCost();
        }
      } else {
        this.labor.price = this.calculationService.roundOff(this.labor.billRate.rate * this.labor.billableHours);
        this.defaultPrice = this.labor.price;
      }

      this.labor.status = true;
      this.labor.itemSource = this.serviceItem.itemSource;
      this.labor.isTaxable = this.serviceItem.isTaxable;
      this.labor.displayHoursOnOrder = this.serviceItem.displayHoursOnOrder;
      this.labor.displayDescOnOrder = this.serviceItem.displayDescOnOrder;
      this.labor.commissionable = this.serviceItem.commissionable;
      this.labor.actualLaborTime = this.serviceItem.actualLaborTime;

      if (this.labor.actualLaborTime && this.motorMarkup) {
        this.labor.markedUpLaborTime = this.calculationService.roundOff(Number(this.labor.actualLaborTime) * (1 + Number(this.motorMarkup) / 100));
      }

      if (this.serviceItem.hasOwnProperty('salesCode') && this.serviceItem.salesCode?.salesCodeId) {
        this.labor.salesCode = this.serviceItem.salesCode;
      }

      if (this.serviceItem.hasOwnProperty('costEstimatedHours')) {
        this.labor.costEstimatedHours = this.calculationService.roundOff(this.serviceItem.costEstimatedHours);
      } else {
        this.labor.costEstimatedHours = this.calculationService.roundOff(this.serviceItem.count);
      }

      if (this.serviceItem.hasOwnProperty('category') && this.serviceItem.category) {
        if (this.isNewCategoriesEnabled) {
          this.labor.category = {
            ...this.serviceItem.category,
          };
        } else {
          this.labor.category = {
            ...this.labor.category,
            ...this.serviceItem.category,
          };
        }
      }

      if (this.labor.costEstimatedHours) {
        this.labor.costRate = this.calculationService.roundOff(this.serviceItem.cost / this.labor.costEstimatedHours);
      }

      //Adding associated items from the service line item aginst the Ticket ALP-20843
      if(this.serviceItem.associatedItems && this.serviceItem.associatedItems?.length) {
        if(this.isOpenFromRO) {
          const getElementFromArray = this.serviceItem.associatedItems.map((itm) => {
            return itm;
          });
          if(getElementFromArray?.length) {
            this.hazmatFeeArray = getElementFromArray;
          }
        }
      }

      // in case of motor actual labor is estimated hrs
      // if (this.labor.itemSource === 'Motor') {
      //   this.labor.costEstimatedHours = this.labor.actualLaborTime || 0;
      //   this.serviceItem.cost = this.labor.costEstimatedHours * this.labor.costRate; // both side motor total cost fixed.
      // }
      if (this.serviceItem.qboId) {
        this.labor.itemRef = { qboId: this.serviceItem.qboId };
        this.setItemRef();
      }

      this.labor.cost = this.calculationService.roundOff(this.serviceItem.cost);
    }
  }

  /** Getting values from the inputs */
  handleChange(name: string, value: string) {
    this.labor[name] = value;

    if (['billRate', 'notes', 'isTaxable', 'billableHours', 'costRate', 'internalNotes', 'price', 'costEstimatedHours'].includes(name)) {
      this.updatedInputStates[name] = this.initalInputStates[name] != value;
    }

    if (this.labor.title) {
      this.checkUniqueTitle();
    }
    if (this.companyLocalization) {
      if (this.labor.titleFR) {
        this.checkUniqueTitle();
      }
    }
    if (name === 'price') {
      this.labor.isPriceManuallyAdded = true;
    }
  }

  handleChangeCategory(name: string, value) {
    this.categoryName = value;
    this.checkUniqueCategory();
  }

  handleClear(type = '') {
    if (type === 'category') {
      this.categoriesSuggestionsResults = this.helperService.deepCopy(this.categoriesSuggestions);
    } else if (type === 'subCategory') {
      this.subCategoriesSuggestionsResults = this.helperService.deepCopy(this.subCategoriesSuggestions);
    } else if (type === 'subSubCategory') {
      this.subSubCategoriesSuggestionsResults = this.helperService.deepCopy(this.subSubCategoriesSuggestionsResults);
    } else {
      this.qboItemRefs = this.helperService.deepCopy(this.defaultQboItems);
    }
  }

  /** Getting values from the dropdown */
  handleSelect(name: string, value: any) {
    this.labor[name] = value;
    if (name === 'billRate') {
      this.updatedInputStates[name] = !this.initalInputStates[name] || this.initalInputStates[name].rate != value.rate;
      this.labor.pricing = {
        pricingId: value._id,
        name: value.name,
      };
      this.calculateLaborPrice();
    }
    if (!this.isPricingManagementEnable || !this.isPricingMatricesManagement || this.isPricingMatricesManagement === undefined) {
      this.isChangeInPriceMatrix = true;
      this.updateGenericItem = false;
    }
  }

  handleRevertToMarkUp(event: Event) {
    event.stopPropagation();
    event.preventDefault();

    this.labor.billableHours = this.labor.markedUpLaborTime;
    this.blurInput('billableHours');
  }

  /** Setting the focused inputs */
  focusInput(type: string) {
    this.focus[type] = true;
    this.errors[type] = '';
    if (type === 'costEstimatedHours' && isNaN(this.labor.costEstimatedHours)) {
      this.labor.costEstimatedHours = '';
    }

    if (type === 'subCategory' && !this.subCategoriesSuggestionsResults?.length) {
      if (this.labor.category?.categoryId) this.getSubCategories(this.labor.category);
    }

    if (type === 'subSubCategory' && !this.subSubCategoriesSuggestionsResults?.length) {
      if (this.labor.category?.categoryId && this.labor.category?.subCategoryId) this.getSubSubCategories(this.labor.category, this.labor.category);
    }
  }

  /** Removeing the errors from the fields */
  blurInput(type: string) {
    this.focus[type] = false;

    if (type === 'title' && this.labor.title) {
      this.checkUniqueTitle();
    }
    if (this.companyLocalization) {
      if (type === 'titleFR' && this.labor.titleFR) {
        this.checkUniqueTitle();
      }
    }

    if (type === 'price') {
      const oPrice = this.calculationService.roundOff(this.labor.price);
      const nPrice = this.calculationService.roundOff(this.defaultPrice);
      const name = 'billRate';

      if (nPrice !== oPrice) {
        let calculateLaborRate;
        calculateLaborRate = Number(this.labor.price) / this.calculationService.roundOff(this.labor.billableHours);
        this.labor.billRate = {
          name: `Labor - ${this.currencyPipe.transform(Math.abs(calculateLaborRate) || 0, this.usd)}`,
          rate: calculateLaborRate,
        };
        this.updatedInputStates[name] = !this.initalInputStates[name] || this.initalInputStates[name].rate != calculateLaborRate;
      }
    }

    if (type === 'billableHours') {
      this.calculateLaborPrice();

      if (this.labor.billableHours !== this.defaultBillableHours && this.defaultBillableHours > 0) {
        this.labor.costEstimatedHours = this.calculationService.roundOff((this.labor.billableHours / this.defaultBillableHours) * this.labor.costEstimatedHours);

        this.defaultBillableHours = this.labor.billableHours;
        this.calculateTotalCost();
      }
    }

    if (type === 'costRate' || type === 'costEstimatedHours') {
      this.calculateTotalCost();
    }

    this.defaultPrice = this.calculationService.roundOff(this.labor.price);
  }

  onSearchItem(query: string) {
    this.httpService.getQBOItemRefs(query).then(
      (data: any) => {
        if (data.items) {
          this.qboItemRefs = data.items.filter(({ type }) => type === 'labor');
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  searchItemCategory(name: string, query: string) {
    if (name === 'category') {
      this.categoriesSuggestionsResults = this.categoriesSuggestions.filter(({ categoryName }) => categoryName && new RegExp(`${query}`, 'gi').test(categoryName));
    } else if (name === 'subCategory') {
      this.subCategoriesSuggestionsResults = this.subCategoriesSuggestions.filter(({ subCategoryName }) => subCategoryName && new RegExp(`${query}`, 'gi').test(subCategoryName));
    } else if (name === 'subSubCategory') {
      this.subSubCategoriesSuggestionsResults = this.subSubCategoriesSuggestions.filter(({ subSubCategoryName }) => subSubCategoryName && new RegExp(`${query}`, 'gi').test(subSubCategoryName));
    }
  }

  calculateLaborPrice() {
    if (this.labor.billableHours && this.labor.billRate && this.labor.billRate.rate >= 0) {
      this.labor.price = this.calculationService.roundOff(this.labor.billableHours * this.labor.billRate.rate);
    }
  }

  calculateTotalCost() {
    if (this.labor.costRate && this.labor.costEstimatedHours) {
      this.labor.cost = this.calculationService.roundOff(this.labor.costRate * this.labor.costEstimatedHours);
    }
  }

  /** Close dialog */
  closeDialog() {
    this.dynamicDialogRef.close();
  }

  /** Validation labor valuese */
  validate() {
    let isValid = true;

    if ((this.labor.billRate && !this.labor.billRate?.name) || !this.labor.billRate) {
      this.errors.billRate = 'Labor rate required';
      isValid = false;
    }

    if (!this.labor.billableHours) {
      this.errors.billableHours = 'Labor hours required';
      isValid = false;
    }

    if (!this.labor.costRate) {
      this.errors.costRate = 'Labor rate required';
      isValid = false;
    }

    if (this.companyLocalization && this.currentLang === 'fr') {
      if (!this.labor.titleFR?.trim()) {
        this.errors.titleFR = 'Title required';
        this.helperService.showToaster('error', 'Labor title is required');
        isValid = false;
      } else if (!this.isTitleUnique) {
        this.errors.titleFR = 'Labor name must be unique';
        this.helperService.showToaster('error', 'Labor name must be unique');
        isValid = false;
      }
    } else {
      if (!this.labor.title?.trim()) {
        this.errors.title = 'Title required';
        this.helperService.showToaster('error', 'Labor title is required');
        isValid = false;
      } else if (!this.isTitleUnique) {
        this.errors.title = 'Labor name must be unique';
        this.helperService.showToaster('error', 'Labor name must be unique');
        isValid = false;
      }
    }

    if (!this.labor.costEstimatedHours && (this.isLocal || !this.orderServiceId)) {
      this.errors.costEstimatedHours = 'Estimated hours required';
      isValid = false;
    }

    return isValid;
  }

  createLabor(labor: any) {
    if (this.isProcessing) {
      return;
    }
    this.isProcessing = true;
    const item = this.helperService.deepCopy(labor);
    if (this.isOpenFromPO || this.orderServiceId) {
      if (this.isSalesCodeEnabled && !this.canEditClassifications) {
        labor.salesCode = this.defaultSalesCode;
      }
    }
    this.httpService.createItem(labor).then(
      (res: any) => {
        this.helperService.showToaster('success', 'Labor Created');
        this.dynamicDialogRef.close();
        this.isProcessing = false;
        this.dataService.sendData(this.dataService.typePassData('part-list', {}));

        if (this.isOpenFromPO || this.orderServiceId) {
          if (this.isSalesCodeEnabled && !this.canEditClassifications) {
            res.salesCode = item?.salesCode;
          }
        }

        if (this.isSalesCodeEnabled) {
          this.logPXGaingSightCustomEvent(res);
        }

        if (this.orderServiceId) {
          this.dataService.sendData(
            this.dataService.typePassData('ro-service-item', {
              ...res,
              actionType: 'create',
              serviceId: this.orderServiceId,
              index: this.orderServiceItemIndex,
            }),
          );
        } else if (this.openFrom === 'cannedService') {
          this.dataService.sendData(this.dataService.typePassData('canned-service-item', { ...res, actionType: 'create' }));
        }
      },
      (err) => {
        this.isProcessing = false;
        this.helperService.showToaster('error', err);
      },
    );
  }
  updateLabor(labor: any) {
    if (this.isProcessing) {
      return;
    }
    this.isProcessing = true;

    if (this.orderServiceId && !this.updateGenericItem) {
      this.dynamicDialogRef.close();
      this.isProcessing = false;
      if (this.isSalesCodeEnabled && this.serviceItem?.salesCode?.salesCodeId !== labor.salesCode?.salesCodeId) {
        this.logPXGaingSightCustomEvent(labor);
      }
      const data = {
        ...labor,
        count: labor.billableHours,
        actionType: 'update',
        isLocal: true,
        serviceId: this.orderServiceId,
        index: this.orderServiceItemIndex,
        isChangeInPriceMatrix: this.isChangeInPriceMatrix,
        isPriceManuallyAdded: this.labor.isPriceManuallyAdded,
      };

      if (this.laborId) {
        data._id = this.laborId;
      }

      this.dataService.sendData(this.dataService.typePassData('ro-service-item', data));
    } else {
      const item = this.helperService.deepCopy(labor);
      if (this.isSalesCodeEnabled && !this.canEditClassifications && this.orderServiceId) {
        labor.salesCode = this.defaultSalesCode;
      }
      this.httpService
        .updateItem({
          ...labor,
          count: labor.billableHours,
          _id: this.laborId,
        })
        .then(
          (res: any) => {
            this.helperService.showToaster('success', 'Labor Updated');
            this.dynamicDialogRef.close();
            this.isProcessing = false;
            this.dataService.sendData(this.dataService.typePassData('part-list', {}));

            if (this.isSalesCodeEnabled && !this.canEditClassifications && this.orderServiceId) {
              res.salesCode = item?.salesCode;
            }

            if (this.isSalesCodeEnabled) {
              this.logPXGaingSightCustomEvent(res);
            }

            if (this.orderServiceId) {
              this.dataService.sendData(
                this.dataService.typePassData('ro-service-item', {
                  ...res,
                  actionType: 'update',
                  serviceId: this.orderServiceId,
                  index: this.orderServiceItemIndex,
                }),
              );
            }

            if (Object.values(this.updatedInputStates).includes(true)) {
              if (this.updatedInputStates.costRate && Object.keys(this.updatedInputStates).length === 1) {
                this.updateCannedService(labor);
              } else {
                this.openUpdateCannedServicesDialog({
                  ...labor,
                  _id: this.laborId,
                });
              }
            }
          },
          (err) => {
            this.isProcessing = false;
            this.helperService.showToaster('error', err);
          },
        );
    }
  }

  async updateCannedService(data) {
    const cannedServices = await this.httpService.getCannedServicesByItem(this.laborId);

    if (cannedServices.length === 0) {
      return;
    }
    const payload = <any>{
      services: cannedServices.map((c: any) => {
        return {
          _id: c._id,
          itemType: c.itemType,
        };
      }),
      itemId: this.laborId,
      isPassThroughTax: data.isPassThroughTax,
    };
    payload.cost = data.costRate * data.costEstimatedHours;
    payload.costRate = data.costRate;
    payload.costEstimatedHours = data.costEstimatedHours;
    await this.httpService.updateCannedServicesByItem(payload);
  }

  /**
   * Get canned services for the provided item
   */
  async openUpdateCannedServicesDialog(data) {
    try {
      const cannedServices = await this.httpService.getCannedServicesByItem(data._id);

      if (cannedServices.length === 0) {
        return;
      }

      // open update canned service dialog
      this.dialogService.open(UpdateCannedServiceDialogComponent, {
        width: '50%',
        styleClass: 'add-dialog add-part update-canned overflow-initial',
        showHeader: false,
        data: {
          part: data,
          cannedServices,
          from: 'labor',
          updatedFields: Object.keys(this.updatedInputStates).filter((key) => {
            try {
              return this.updatedInputStates[key];
            } catch (e) {
              return false;
            }
          }),
        },
      });
    } catch (error) {
      this.helperService.showToaster('error', error);
    }
  }

  onSubmit() {
    if (this.validate()) {
      const hazamFeeList = [];

      this.hazmatFeeArray.map((itm) => {
        if (itm && itm._id) {
          hazamFeeList.push({ itemId: itm._id });
        }
      });

      const labor: any = {
        type: 'labor',
        title: this.labor.title,
        titleFR: this.labor.titleFR,
        code: this.labor.code,
        billRate: this.labor.billRate ? this.labor.billRate.rate : 0,
        billableHours: this.labor.billableHours,
        price: this.calculationService.roundOff(this.labor.price),
        costEstimatedHours: this.calculationService.roundOff(this.labor.costEstimatedHours),
        costRate: this.labor.costRate,
        cost: this.labor.cost,
        qboItemRefId: this.labor.itemRef ? this.labor.itemRef.qboId : '',
        locationQboItemRefId: this.labor.locationQboItemRefId || {},
        status: this.labor.status,
        isTaxable: this.labor.isTaxable,
        displayHoursOnOrder: this.labor.displayHoursOnOrder,
        displayDescOnOrder: this.labor.displayDescOnOrder,
        commissionable: this.labor.commissionable,
        descriptionFR: this.labor.descriptionFR,
        notes: this.labor.notes,
        internalNotes: this.labor.internalNotes,
        description: this.labor.notes,
        associatedItems: hazamFeeList,
        category: this.labor.category || {},
      };

      if (this.labor.pricing && this.labor.pricing.pricingId) {
        labor.pricing = this.labor.pricing;
      }

      if (this.isNewCategoriesEnabled && this.isSalesCodeEnabled) {
        if (this.labor.salesCode && this.labor.salesCode?.salesCodeId) labor.salesCode = this.labor.salesCode;
        else labor.salesCode = {};
      }

      if (this.labor.itemRef && this.labor.itemRef.qboId) {
        labor.qboId = this.labor.itemRef.qboId;
        if (this.isMultiLocationEnabled) {
          labor.locationQboItemRefId[this.currentShopId] = labor.qboId;
        }
      }

      this.errors = {};

      if (this.isNewItemCategoriesEnable && this.isSalesCodeEnabled) {
        labor.isAutoAssign = this.isAutoAssign;
      }

      if (!labor.shopDetails || labor.shopDetails.length === 0) {
        labor.shopDetails = [
          {
            shopId: this.helperService.getCurrentShopId(),
            price: this.labor.price,
          },
        ];
      } else {
        const shopLevelDetails = findIndex(labor.shopDetails, {
          shopId: this.helperService.getCurrentShopId(),
        });
        if (shopLevelDetails === -1) {
          labor.shopDetails.push({
            shopId: this.helperService.getCurrentShopId(),
            price: this.labor.price,
          });
        } else {
          labor.shopDetails[shopLevelDetails].price = this.labor.price;
        }
      }

      if (this.laborId || (this.serviceItem && this.serviceItem.itemId)) {
        this.updateLabor(labor);
      } else {
        this.createLabor(labor);
      }
    }
  }

  displaySalesCodeTitle() {
    return this.helperService.displaySalesCodeTitle(this.labor.salesCode, this.labor.category);
  }

  removeHazmatFee(index) {
    this.hazmatFeeArray.splice(index, 1);
  }

  addAnotherFee() {
    this.hazmatFeeArray.push(this.helperService.deepCopy(this.hazmatFeeObject));
  }

  onROSelect(item, index) {
    this.hazmatFeeArray[index] = item;
    this.itemResults.map((searchList, i) => {
      this.itemResults[i] = searchList.filter((itm) => itm._id !== item._id);
    });
  }

  onSearchClear(index) {
    this.itemResults[index] = [];
  }

  onSearchEnter(query: string) {}

  searchSuggestion(query: string, index) {
    this.isSearching = true;
    this.httpService
      .getItems({
        limit: 100,
        search: query.trim(),
        type: 'hazmatFee',
      })
      .then(
        (data: any) => {
          this.itemResults[index] = [];
          if (data.records) {
            if (this.hazmatFeeArray.length > 0) {
              this.itemResults[index] = data.records.filter(({ _id, title }) => !this.hazmatFeeArray.find((fee: any) => fee && fee._id === _id && fee.title === title));
            } else {
              this.itemResults[index] = data.records;
            }
          }
        },
        (err) => {
          this.isSearching = false;
          this.helperService.showToaster('error', err);
        },
      )
      .finally(() => {
        this.isSearching = false;
      });
  }

  showSuggestions(type?: string) {
    if (type === 'tags') {
      this.categoryResults = [...this.categories];
    }
    this.isShowError = false;
  }

  onUpdateItem({ name, color, _id }, type: string) {
    const tag = {
      _id,
      color: color,
      type: this.categoryType ? this.categoryType : type,
      name: name.trim(),
    };

    this.httpService.updateTag(tag).then(
      (data) => {
        for (let i = 0; i < this.categories.length; i++) {
          if (this.categories[i]._id === _id) {
            this.categories[i].name = name;
            break;
          }
        }

        for (let i = 0; i < this.categoryResults.length; i++) {
          if (this.categoryResults[i]._id === _id) {
            this.categoryResults[i].name = name;
            break;
          }
        }

        if (this.labor.category && this.labor.category._id === _id) {
          this.labor.category.name = name;
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }
  saveCategory({ name }) {
    this.createCategory({
      name,
      type: this.categoryType ? this.categoryType : config.tags.labor,
      color: '',
    });
  }

  createCategory(data: any) {
    this.httpService.createTag(data).then(
      (category: any) => {
        if (category) {
          this.helperService.showToaster('success', messages.categoryCreated);
          this.categories.push(category);
          const data = {
            name: category.name,
            categoryId: category._id,
            _id: category._id,
          };
          this.onAutoCompleteSelect(data, 'tags');
          this.categoryResults = [...this.categories];
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  onAutoCompleteSelect(event: any, type?: string) {
    if (type === 'tags') {
      this.labor.category = event;
    }
  }

  onClearSuggestion(type: string = '') {
    if (type === 'tags') {
      this.categoryResults = [...this.categories];
    }
  }

  searchSuggestionCategory(query: string, type?: string) {
    this.categoryResults = [];
    query = this.helperService.trimString(query);
    if (type === 'tags') {
      this.categoryResults = this.categories.filter(({ name }) => {
        if (name && new RegExp(`${query}`, 'gi').test(name)) {
          return true;
        } else {
          return false;
        }
      });
    }
  }

  categoryDropdownSelect(type: string, event: any) {
    const payload: any = { salesCode: event.salesCode };

    if (type === 'category' && event.categoryId) {
      delete this.labor?.category?.subCategoryId;
      delete this.labor?.category?.subCategoryName;
      delete this.labor?.category?.subSubCategoryId;
      delete this.labor?.category?.subSubCategoryName;
      this.getSubCategories(event);
      this.subCategoriesSuggestions = [];
      this.subCategoriesSuggestionsResults = [];
      this.subSubCategoriesSuggestions = [];
      this.subSubCategoriesSuggestionsResults = [];
      payload.category = event;
    }

    if (type === 'subCategory' && event.subCategoryId) {
      delete this.labor?.category?.subSubCategoryId;
      delete this.labor?.category?.subSubCategoryName;
      this.getSubSubCategories(this.labor.category, event);
      this.subSubCategoriesSuggestions = [];
      this.subSubCategoriesSuggestionsResults = [];
      payload.category = {
        categoryId: this.labor.category.categoryId,
        categoryName: this.labor.category.categoryName,
      };
      payload.subCategory = event;
    }

    if (type === 'subSubCategory' && event?.subSubCategoryId) {
      payload.category = {
        categoryId: this.labor.category.categoryId,
        categoryName: this.labor.category.categoryName,
      };
      payload.subCategory = {
        subCategoryId: this.labor.category.subCategoryId,
        subCategoryName: this.labor.category.subCategoryName,
      };
      payload.subSubCategory = event;
    }

    this.onSelectCategory(payload);
  }

  openConfirmationDialog(salesCode: any) {
    let title: string = 'Confirmation';
    let message: string =
      'Updating the item classification will also auto-update the Sales Code based on the new item classification. If a Sales Code was previously assigned to this item, it will be replaced with the new sales code. Are you sure you want to proceed?';
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-18 font-700',
        title: title,
        message: message,
        button: {
          success: { title: 'Proceed' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess }) => {
      if (isSuccess) {
        this.labor.salesCode = salesCode;
        //this.salesCodeOverideConfirm = true;
      }
      onClose.unsubscribe();
    });
  }

  onSelectCategory(event: any) {
    const { category, salesCode, isAutoAssign } = this.helperService.onCategorySelect(event, this.labor.salesCode?.salesCodeId);

    this.labor.category = category;
    if (this.labor.salesCode?.salesCodeId && salesCode?.salesCodeId !== this.labor.salesCode?.salesCodeId) {
      this.openConfirmationDialog(salesCode);
    } else {
      this.labor.salesCode = salesCode;
    }

    this.isAutoAssign = isAutoAssign;

    this.subCategoriesSuggestions = [];
    this.subCategoriesSuggestionsResults = [];
    this.subSubCategoriesSuggestions = [];
    this.subSubCategoriesSuggestionsResults = [];
  }

  getAllCategories() {
    const query: any = { itemType: 'labor' };
    this.loader.category = true;
    // if (this.query) query.searchTerm = encodeURI(this.query);
    this.httpService
      .getPricingCategories(query)
      .then((res: any) => {
        res.categories = res.categories.filter((category) => category.categoryName && category._id);
        this.categoriesSuggestions = res.categories;
        this.categoriesSuggestionsResults = this.helperService.deepCopy(this.categoriesSuggestions);
      })
      .finally(() => {
        this.loader.category = false;
      });
  }

  getSubCategories(item) {
    this.loader.subCategory = true;
    this.httpService
      .getPricingSubCategories(item.categoryId, 'labor')
      .then((res: any) => {
        if (res && res.subCategories?.length) {
          this.subCategoriesSuggestions = res.subCategories;
          this.subCategoriesSuggestionsResults = this.helperService.deepCopy(this.subCategoriesSuggestions);
        } else {
          this.subCategoriesSuggestions = [];
          this.subCategoriesSuggestionsResults = [];
        }
      })
      .finally(() => {
        this.loader.subCategory = false;
      });
  }

  getSubSubCategories(item, level2) {
    this.loader.subSubCategory = true;
    this.httpService
      .getPricingSubSubCategories(item.categoryId, level2.subCategoryId, 'labor')
      .then((res: any = {}) => {
        if (res && res.subSubCategories?.length) {
          this.subSubCategoriesSuggestions = res.subSubCategories;
          this.subSubCategoriesSuggestionsResults = this.helperService.deepCopy(this.subSubCategoriesSuggestions);
        } else {
          this.subSubCategoriesSuggestions = [];
          this.subSubCategoriesSuggestionsResults = [];
        }
      })
      .finally(() => {
        this.loader.subSubCategory = false;
      });
  }
}
